export function initReviewCarousels() {
  document.querySelectorAll(".review-carousel").forEach((carousel) => {
    const track = carousel.querySelector(".review-carousel__track");
    const prevBtn = carousel.querySelector(".review-carousel__btn--prev");
    const nextBtn = carousel.querySelector(".review-carousel__btn--next");
    if (!track || !prevBtn || !nextBtn) return;

    // Cards have varying widths, so pages by most of the visible width and lets scroll-snap align the result
    const scrollByPage = (direction) => {
      track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: "smooth" });
    };

    // Tolerance absorbs sub-pixel rounding and the snap padding at the scroll edges
    const EDGE_TOLERANCE_PX = 10;
    const updateButtons = () => {
      prevBtn.disabled = track.scrollLeft <= EDGE_TOLERANCE_PX;
      nextBtn.disabled =
        track.scrollLeft + track.clientWidth >= track.scrollWidth - EDGE_TOLERANCE_PX;
    };

    prevBtn.addEventListener("click", () => scrollByPage(-1));
    nextBtn.addEventListener("click", () => scrollByPage(1));
    track.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);
    updateButtons();
  });
}
